



const appUploadStatus = 'active'





class settings {

    _getAppUploadStatus() {
        return appUploadStatus
    }



}

export default new settings()